import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import breaks from 'remark-breaks';
import styles from './text.scss';

class Text extends Component {


  linkRenderer(props) {
    const tempLink = document.createElement('a');
    tempLink.href = props.href;
    const isExternal = tempLink.hostname !== window.location.hostname;
    const target = isExternal ? '_blank' : '_self';
    return <a href={props.href} target={target}>{props.children}</a>
  }
  
  render() {
    const { text } = this.props;

    return (
      <section className={styles.text}>
        <ReactMarkdown source={text} plugins={[breaks]} renderers={{link: this.linkRenderer}}/>
      </section>
    );
  }
}

Text.propTypes = {
  text: PropTypes.string.isRequired
}

export default Text;



// WEBPACK FOOTER //
// ./src/components/text/text.jsx